// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"218":"component---src-pages-404-tsx","578":"component---src-templates-figure-tsx","691":"component---src-pages-index-tsx"}[chunkId] || chunkId) + "-" + {"218":"483b406b3ebd625ca3cc","578":"d0ed543f2924e59366dd","691":"950c5c3a8cd65ad20e44","731":"03c59766c06e6b3ed43d","843":"3e9fe0fa935389483844"}[chunkId] + ".js";
};